

import axiosClient from '../axiosClient';

export const orderHeaderApi = {
  getOrderHeaders: async (page = 0, size = 20, search = '', month = '', status = '', sortBy = '', sortOrder = 'desc', year = '') => {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        size: size.toString(),
      });

      if (search && search.trim() !== '') {
        params.append('search', search.trim());
      }

      if (month && month.trim() !== '') {
        params.append('month', month.trim());
      }

      if (status && status.trim() !== '') {
        params.append('status', status.trim());
      }

      if (year && year.toString().trim() !== '') {
        params.append('year', year.toString().trim());
      }

      if (sortBy && sortBy.trim() !== '') {
        params.append('sortBy', sortBy.trim());
        params.append('sortOrder', sortOrder);
      }

      console.log('📦 Fetching order headers with params:', params.toString());

      const data = await axiosClient.get(`/order-headers?${params.toString()}`);

      console.log('📦 Order Headers API data:', data);

      return data;
    } catch (error) {
      console.error('Error fetching order headers:', error);
      throw error;
    }
  },

  exportOrderHeaders: async (search = '', month = '', status = '', year = '') => {
    try {
      const params = new URLSearchParams();

      if (search && search.trim() !== '') {
        params.append('search', search.trim());
      }

      if (month && month.trim() !== '') {
        params.append('month', month.trim());
      }

      if (status && status.trim() !== '') {
        params.append('status', status.trim());
      }

      if (year && year.toString().trim() !== '') {
        params.append('year', year.toString().trim());
      }

      console.log('📊 Exporting order headers with params:', params.toString());

      const data = await axiosClient.get(`/order-headers/export?${params.toString()}`);
      return data;
    } catch (error) {
      console.error('Error exporting order headers:', error);
      throw error;
    }
  },

  getOrderDetails: async (orderNum) => {
    try {
      console.log('🔍 Fetching order details for:', orderNum);
      const data = await axiosClient.get(`/order-headers/${orderNum}`);
      return data;
    } catch (error) {
      console.error('Error fetching order details:', error);
      throw error;
    }
  },

  getOrderYears: async () => {
    try {
      console.log('📅 Fetching available order years...');
      const data = await axiosClient.get(`/order-headers/years`);
      console.log('📅 Available years:', data);
      return data;
    } catch (error) {
      console.error('Error fetching order years:', error);
      throw error;
    }
  },
};